angular.
module("dx.webapp.exam").
constant("DX_USB_AUDIO_SETTING", Object.freeze({
	UsbAudioSettingAllowOverride: 0,
	UsbAudioSettingAllowAll: 1,
	UsbAudioSettingDenyAll: 2,
}));
